/**
 * Vulnerabilities Table Configuration
 *
 * Centralized configuration for vulnerabilities table column widths,
 * default settings, and table-specific constants.
 */

import {
  COMMON_COLUMN_WIDTHS,
  generateStorageKey,
} from '@/utils/tableConfig.util';

/**
 * Column width tokens for vulnerabilities table
 * Note: All columns now use fixed widths for consistent column sizing
 */
export const VULNERABILITY_COLUMN_WIDTHS = {
  status: 150,
  priority: 120, // Severity
  name: 300,
  cvss: 100,
  epss: 100,
  kev: 100,
  ticket: 160,
  origins: 140,
  created: COMMON_COLUMN_WIDTHS.timestamp, // First Seen
  visited: COMMON_COLUMN_WIDTHS.timestamp, // Last Seen
  guid: 85,
} as const;

/**
 * Default column order for vulnerabilities table
 */
export const VULNERABILITY_DEFAULT_COLUMN_ORDER = [
  'status',
  'priority',
  'name',
  'origins',
  'created',
  'visited',
] as const;

/**
 * Available columns (not shown by default)
 */
export const VULNERABILITY_AVAILABLE_COLUMNS = [
  'cvss',
  'epss',
  'kev',
  'ticket',
  'guid',
] as const;

/**
 * Complete vulnerabilities table configuration
 */
export const VULNERABILITY_TABLE_CONFIG = {
  widths: VULNERABILITY_COLUMN_WIDTHS,
  defaultColumnOrder: VULNERABILITY_DEFAULT_COLUMN_ORDER,
  hiddenColumns: [],
  storageKey: generateStorageKey('vulnerabilities', undefined, 2),
  // Row height accounts for content (52px) + browser default cell padding (~12px vertical)
  // Actual measured height: 64px across all zoom levels (67%, 88%, 94%, 100%)
  defaultRowHeight: 64,
} as const;
